/* eslint-disable camelcase */

import React from 'react';

import ADGMItemDetails from 'aurora-components/ADGMItemDetails/ADGMItemDetails';
import Radio from '@material-ui/core/Radio';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import CompanyImage from 'aurora-images/Company_avatar.svg';
import PropTypes from 'prop-types';

function SelectCard({ classes, entityDetails, activeEntity, setActiveEntity, locale }) {
  const EntityDataToBeShown = [
    { label: 'license_number', value: entityDetails?.tradeLicenseNumber },
    { label: 'Email', value: entityDetails?.companyEmail },
    { label: 'phone_number', value: entityDetails?.mobileNumber },
  ];
  return (
    <Grid container className={classes.SelectCardContainer}>
      <Grid item>
        <Radio
          value='card'
          name='radio-button-demo'
          inputProps={{ 'aria-label': 'select-government' }}
          id='userRadioA'
          checked={activeEntity.companyId === entityDetails.companyId}
          onClick={() => setActiveEntity(entityDetails)}
          classes={{ root: classes.itemCheckbox, checked: classes.itemCheckboxChecked }}
        />
      </Grid>
      <Grid item>
        <Avatar className={classes.avatarImg} alt='avatar img' src={CompanyImage} />
      </Grid>
      <Grid item>
        <ADGMItemDetails
          label='Name'
          value={locale === 'ar' ? entityDetails?.companyNameAr : entityDetails?.companyNameEn}
          labelClass={classes.lightThinLabel}
          valueClass={classes.lightThinValue}
        />
      </Grid>
      <Grid item xs={12} className={classes.padding}>
        <Divider />
      </Grid>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          {EntityDataToBeShown.map(({ label, value }) => (
            <Grid key={label} item xs={4}>
              <ADGMItemDetails
                label={label}
                value={value}
                labelClass={classes.lightThinLabel}
                valueClass={classes.lightThinValue}
                containerClass={classes.itemDetailsContainer}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
}

SelectCard.propTypes = {
  classes: PropTypes.object.isRequired,
  entityDetails: PropTypes.object.isRequired,
  activeEntity: PropTypes.object.isRequired,
  setActiveEntity: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
};

export default SelectCard;
